import { useAtom } from 'jotai'
import { createAtom } from './atomFactory'
import { MMKVKey } from '../mmkv'

const { atom } = createAtom(false, MMKVKey.SeenWelcomeLogo)

export const useWelcomeAnimation = () => useAtom(atom)
